import { defineStore } from "pinia";
import { ref } from "vue";
import { RouteLocationNormalized } from "vue-router";

export const useNavigationStore = defineStore("navigationStore", () => {
  const previousRoute = ref<RouteLocationNormalized | null>(null);

  return { previousRoute };
});
